import { Injectable } from '@angular/core';

import { VueAccountManagementService, VueSecurityQuestionGroup } from '@vue/vueframework';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SecurityQuestionsResolve {
  public constructor(private vueAccountManagementService: VueAccountManagementService) { }

  public resolve(): Observable<VueSecurityQuestionGroup[]> {
    return this.vueAccountManagementService.getSecurityQuestionGroups()
      .pipe(
        catchError(() => {
          return of(null);
        })
      );
  }
}
